import Api from '../http/ApiService'

export class AuthService {
  static authenticate = (email, password) =>
    Api.post('/authenticate', { username: email, password })
}

export default AuthService